import React from "react"
import AddIndItemdetails from "./AddIndItemDetails" // import row item details 
import DatePicker from "./DatePicker" // import DatePicker 
import axios from 'axios';
import Navbar from '../Navbar';
import { format } from 'date-fns';
import swal from 'sweetalert';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Link, useNavigate,useParams } from 'react-router-dom';
import {
    createTheme,
    PaletteColorOptions,
    ThemeProvider,
  } from '@mui/material/styles';
  import { Stack } from '@mui/material';



class AddIndChallan extends React.Component {

    // state define 
    constructor(props) {
        super(props)
        this.state = {
            addMore: [{ index: Math.random(), distin: "", sn: "", descriptive: "", test: "", pltonns: "",swltonns: "", subcategory: "", categoryname: "", item: "",nostest_remarks:"",swltonns2:""}],//item list
            date: "",
            month_of_test: "",
            party_code: "",
            party_name: "",
            remarks: "",
            ship_name:"",
            verticle_type: "",
            serial_type: "",
            tested: "",
            user_id:localStorage.getItem("auth_id"),
            address: "",
            associate_code: "",
            party_code_list:[],
            posts:[],
            series:[],
            error_list: [],
            enddate:""
        };
    }

    // get party all code 
    componentDidMount(){
        //api call
        fetch('https://cert.geekay.biz/backend/api/view-customer').then(resp=>resp.json()) //production
        // fetch('/api/view-customer').then(resp=>resp.json()) //local
        .then(resp=>this.setState({posts:resp.customer}))

        fetch('https://cert.geekay.biz/backend/api/get_serial').then(resp=>resp.json()) //production
        // fetch('/api/get_serial').then(resp=>resp.json()) //local
        .then(resp=>this.setState({series:resp.series}))

    }
    


    // handle input changes
    handleChange = (e) => {
        if (["distin", "sn", "descriptive", "test", "pltonns", "swltonns","subcategory","categoryname","nostest_remarks","swltonns2"].includes(e.target.name)) {
            let addMore = [...this.state.addMore]
            addMore[e.target.dataset.id][e.target.name] = e.target.value;
        } else {
            this.setState({ [e.target.name]: e.target.value })
        }
    }

    // handle input changes
    handleChangeDate = (e) => {

        var dateToday = new Date();
        // console.log(dateToday)
    }

    // party name , associate_code, and Address populate using party code 
    handlePartyCode = (e) => {
        const partyCode = e.target.value;
        axios.get(`/api/party_name/${partyCode}`).then(res=>{
            if(res.data.status===200){
                // console.log(res.data.customer[0])
                let PName= res.data.customer[0].name;
                let acode= res.data.customer[0].acode;
                let address= res.data.customer[0].maddress;
                this.setState({party_name:PName})
                this.setState({associate_code:acode})
                this.setState({address:address})
                document.getElementById("party_name").value = PName;
                document.getElementById("associate_code").value = acode;
                document.getElementById('address').value = address;
                
            }
            });
    }

    //  Add new row Item details
    addNewRow = () => {
        this.setState((prevState) => ({
            addMore: [...prevState.addMore, { index: Math.random(), distin: "", sn: "", descriptive: "", test: "", pltonns: "", swltonns: ""
        , subcategory: "", categoryname: "", item: "",nostest_remarks:"",swltonns2:""}],
        }));
    }


    datepicker = () => {
        this.setState({date:""});
        // console.log(this.props)
    }
    // submit input action call backend Api and store data
    handleSubmit = (e) => {
        e.preventDefault();
       
        let data = this.state
       

        axios.post(`api/store_challan_details`,data).then(res =>{
            // console.log(res.data.status)
        if(res.data.status===200){
            // swal("Success", res.data.message,"success");
            document.getElementById('add_challan').reset();
            window.location.href = '/certificates/show_inds_chalans';
        }
        else if(res.data.status===400){
            this.setState({...this.state, error_list:res.data.errors});
        }
        });

    }
    
    
    //  delete addMore detals Row
    clickOnDelete(record) {
        this.setState({
            addMore: this.state.addMore.filter(r => r !== record)
        });
    }

    // create form field data 
    render() {
        let { addMore } = this.state //collected data add more all field 
        return (
            <div className="content">
            <Navbar />
                <NotificationContainer />
                <form id= "add_challan" onSubmit={this.handleSubmit} onChange={this.handleChange} >
                    <div className="row" style={{ marginTop: 20, width: "97%" }}>
                        // <div className="col-sm-1"></div>
                        <div className="col-sm-12" style={{ marginLeft: 40 }}>
                            <div className="card">
                                <div className="card-header"><h4><b>Add Industrial Challan Details</b></h4>
                                 </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Verticle Type</label>
                                                <select id="verticle_type" name="verticle_type" className="form-control" >
                                                    <option value="">-- Verticle Type --</option>
                                                    <option value="Industrial-MZ">Industrial-MZ</option>
                                                    <option value="Industrial-MA">Industrial-MA</option>
                                                    {/* <option value="IDLR">IDLR</option> */}
                                                </select>
                                                <span style={{color: "red"}} >{this.state.error_list.verticle_type}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Party Code</label>
                                                <select name="party_code" id="party_code" className="form-control" onChange={this.handlePartyCode}>
                                                    <option value="">-- Party Code --</option>
                                                    {this.state.posts.map(post=><option key={post.pcode}>{post.pcode}{post.title}</option>)}
                                                </select>
                                                <span style={{color: "red"}} >{this.state.error_list.party_code}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Party Name</label>
                                                <input type="taxt" name="party_name" id="party_name"  className="form-control" placeholder="Party Name" />
                                                <span style={{color: "red"}} >{this.state.error_list.party_name}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Associate Code</label>
                                                <input type="taxt" name="associate_code" id="associate_code"  className="form-control" placeholder="Associate Code" />
                                                <span style={{color: "red"}} >{this.state.error_list.associate_code}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Address</label>
                                                <input type="text" name="address" id="address"  className="form-control" placeholder="Address" />
                                                <span style={{color: "red"}} >{this.state.error_list.address}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Date</label>

                                                {/* <input onChange={this.handleChangeDate} type="date"  name="date" id="date" className="form-control" placeholder="Enter Date" min={this.startdate} max={this.enddate}/>*/}
                                                
                                                <span id="dataRemark" style={{color: "red",display:"none"}} disabled={false} >Not open Month plz maintain Month master</span>
                                                {/* --------------------get month  ----------------*/}
                                                <DatePicker date={this.datepicker}   />
                                                <span style={{color: "red"}} >{this.state.error_list.date}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group">
                                                <label className="required" style={{ marginBottom: "7px" }}>Tested</label>
                                                <select name="tested" className="form-control" >
                                                    <option value="">-- Select status --</option>
                                                    <option value="O.K">O.K</option>
                                                    <option value="Rejected">Rejected</option>
                                                </select>
                                                <span style={{color: "red"}} >{this.state.error_list.tested}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Remarks</label>
                                                <input type="taxt" name="remarks" id="remarks" className="form-control" placeholder="Enter Remarks" />
                                                <span style={{color: "red"}} >{this.state.error_list.remarks}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Series</label>
                                                <select id="serial_type" name="serial_type" className="form-control" >
                                                    <option value="">-- Series Name --</option>
                                                    {this.state.series.map(post=><option key={post.pcode}>{post.series_name}</option>)}
                                                </select>
                                                <span style={{color: "red"}} >{this.state.error_list.serial_type}</span>
                                            </div>
                                        </div> 
                                        {/* <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                            <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>Ship Name</label>
                                                <textarea type="text" name="ship_name" id="ship_name"  className="form-control" placeholder="Ship Name" />
                                                <span style={{color: "red"}} >{this.state.error_list.Ship_name}</span>
                                            </div>
                                        </div> */}

                                        {/* <div className="col-sm-4">
                                            <div className="form-group ">
                                                <label className="required">Description</label>
                                                <textarea name="description"  id="description" className="form-control"></textarea>
                                            </div>
                                        </div> */}
                                    </div >

                                    {/* --------------------Item details Add more Display data Start ----------------*/}
                                    <table class="table table-bordered" style={{ marginTop: "30px" }}>
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{ width: "15%" }} >Category</th>
                                                <th scope="col" style={{ width: "15%" }}>Distinguish Mark</th>
                                                <th scope="col" style={{ width: "25%" }}>Description/Dimension & Material of Gear/Device</th>
                                                <th scope="col" style={{ width: "12%" }} >Nos. Tests</th>
                                                <th scope="col" style={{ width: "12%" }} >P.L. Tonns</th>
                                                <th scope="col" style={{ width: "12%" }} >SWL Tonns</th>
                                                <th scope="col" style={{ width: "8%" }} >SWL Select</th>
                                                <th scope="col" style={{ width: "2%" }} >#</th>
                                                
                                            </tr>
                                        </thead>
                                    {/* -------------------- Create Add and Delete both Functions Delete row and Add row  ----------------*/}
                                        <tbody>
                                            <AddIndItemdetails add={this.addNewRow} delete={this.clickOnDelete.bind(this)} addMore={addMore} /> 
                                        </tbody>
                                    </table>
                                    {/* --------------------Item details Add more Display data End ----------------*/}
                                </div>
                                <div className="card-footer text-center"> <button type="submit" id="submit" style={{ backgroundColor: "#A38A00", color: "white" }} className="btn btn-default text-center" disabled={false}>Submit</button></div>
                            </div>
                        </div>
                        // <div className="col-sm-1"></div>
                    </div>
                </form>
            </div>
        )
    }
}

export default AddIndChallan